const $ = jQuery.noConflict();
class MobileHeader {
	constructor(
		trigger = '.btn-hamburger',
		back = '.mobile-nav-btn-back',
		pbody = 'body',
		listParent = '.menu-item-has-children > a',
		logo = '.main-header__logo img',
		cta = '.mobile-cta-container',
		rootMenuItem = '.menu > li.menu-item > a' // Root-level items
	) {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
		this.logo = logo;
		this.back = back;
		this.cta = cta;
		this.rootMenuItem = rootMenuItem;
		this.wasMobile = this.isMobile();
	}

	init() {
		// Clean up any existing event listeners before reinitializing
		this.unbindEvents();

		// Apply the root-level click prevention on both mobile and non-mobile devices
		$(this.rootMenuItem).on('click', this.preventRootClick.bind(this));

		// Initialize mobile-specific behavior if mobile
		if (this.isMobile()) {
			$(this.trigger).on('click', this.setNavState.bind(this));
			$(this.listParent).on('click', this.setListState.bind(this));
			$(this.back).on('click', this.backButton.bind(this));
		}
	}

	isMobile() {
		// Adjust the breakpoint as necessary
		return window.matchMedia('(max-width: 992px)').matches;
	}

	// Prevent default behavior only if the root-level menu item has children
	preventRootClick(e) {
		const $target = $(e.currentTarget).parent();

		// Check if the root menu item has children (sub-menu)
		if ($target.hasClass('menu-item-has-children')) {
			e.preventDefault(); // Prevent navigation
		}
	}

	setNavState(e) {
		e.preventDefault();
		const body = $('body');
		if ($(e.currentTarget).hasClass('open')) {
			MobileHeader.hideWrapper(e.currentTarget, body);
		} else {
			MobileHeader.showWrapper(e.currentTarget, body);
		}
	}

	backButton(e) {
		e.preventDefault();
		$('.main-header__logo img').css('display', 'block');
		$('.mobile-nav-btn-back').css('display', 'none');
		$('.parent-open').removeClass('parent-open');
		$('.menu .open').removeClass('open');
		$('.mobile-cta-container').css('display', 'block');
		$('.secondary-mobile-nav').css('display', 'flex');
	}

	setListState(e) {
		e.preventDefault();
		if (!$(e.currentTarget).hasClass('open')) {
			$(e.currentTarget).addClass('open');
			$(e.currentTarget).parent().addClass('parent-open');
			$('.main-header__logo img').css('display', 'none');
			$('.mobile-nav-btn-back').css('display', 'flex');
			$('.mobile-cta-container').css('display', 'none');
			$('.secondary-mobile-nav').css('display', 'none');
		} else {
			$(e.currentTarget).parent().removeClass('parent-open');
			$(e.currentTarget).removeClass('open');
			$('.main-header__logo img').css('display', 'block');
			$('.mobile-nav-btn-back').css('display', 'none');
			$('.mobile-cta-container').css('display', 'block');
			$('.secondary-mobile-nav').css('display', 'flex');
		}
	}

	static hideWrapper(el, body) {
		$(el).removeClass('open');
		body.removeClass('overlaid');
		$(el).next().removeClass('active');
		$('.open').removeClass('open');
		$('.parent-open').removeClass('parent-open');
		$('.main-header__logo img').css('display', 'block');
		$('.mobile-nav-btn-back').css('display', 'none');
		$('.secondary-mobile-nav').css('display', 'none');
	}

	static showWrapper(el, body) {
		$(el).addClass('open');
		body.addClass('overlaid');
		$(el).next().addClass('active');
		$('.mobile-cta-container').css('display', 'block');
		$('.secondary-mobile-nav').css('display', 'flex');
	}
	unbindEvents() {
		// Unbind mobile-specific event listeners
		$(this.trigger).off('click');
		$(this.listParent).off('click');
		$(this.back).off('click');

		// Unbind root-level click prevention
		$(this.rootMenuItem).off('click');
	}

	resized() {
		const isCurrentlyMobile = this.isMobile();
		// Check if the trigger is hidden but currently has the 'open' class
		if (
			!$(this.trigger).is(':visible') &&
			$(this.trigger).hasClass('open')
		) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
		// Reinitialize the menu when transitioning into mobile view
		if (isCurrentlyMobile && !this.wasMobile) {
			this.init(); // Reinitialize mobile-specific behavior
		}
		// Reinitialize the menu when transitioning out of mobile view
		if (!isCurrentlyMobile && this.wasMobile) {
			this.init(); // Ensure correct desktop-specific behavior
		}
		// Update the mobile state for future checks
		this.wasMobile = isCurrentlyMobile;
	}
	hideOutsideClick(e) {
		if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
			const container = $('.main-header');
			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0
			) {
				MobileHeader.hideWrapper(this.trigger, $(this.pbody));
			}
		}
	}
}

export default MobileHeader;
